import React from 'react';
import '../css/sticky-message.less';

const StickyMessage = props => {
    const {
        title,
        status="info",
        children,
    } = props;
    const [disabled, setDisabled] = React.useState(false);
    const toggle = React.useCallback(() => setDisabled(!disabled));

    const classNames = [
        "sticky-message__container",
        status
    ].join(" ");

    return disabled ? null : (
        <div className={classNames} onClick={toggle}>
            <h2>{title}</h2>
            {children}
        </div>
    );
}

export default StickyMessage;